// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import ThemeOne from "../themes/theme-one";
// import Portfolio from "../themes/portfolio";
// import PortfolioSingle from "../themes/portfolio-single";
// import About from "../themes/about";
// import Blog from "../themes/blog";
// import BlogSingle from "../themes/blog-single";
// import Contact from "../themes/contact";
// import ProductsDropdown from "../components/Header/ProductsDropdown";
// import Customers from "../components/Customers/Customers";
// import Resources from "../components/Resources/Resources";
// import DynamicProduct from "../components/Products/DynamicProduct";
// import DynamicSolution from "../components/Solutions/DynamicSolution";
// import Preloader from "../components/Miscellaneous/Preloader";
// import ScrollToTop from "../ScrollToTop";

// const MyRoutes = () => {
//   return (
//     <Router>
//         <Preloader/>
//         <ScrollToTop/>
//       <Routes>
//         <Route path="/" element={<ThemeOne />} />
//         <Route path="/portfolio" element={<Portfolio />} />
//         <Route path="/portfolio-single" element={<PortfolioSingle />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/blog" element={<Blog />} />
//         <Route path="/blog-single" element={<BlogSingle />} />
//         <Route path="/contact" element={<Contact />} />
//         <Route path="/product-dropdown" element={<ProductsDropdown />} />
//         <Route path="/product/:productName" element={<DynamicProduct />} />
//         <Route path="/solution/:solutionName" element={<DynamicSolution />} />
//         <Route path="/Customers" element={<Customers />} />
//         <Route path="/Resources" element={<Resources />} />
//       </Routes>
//     </Router>
//   );
// };

// export default MyRoutes;




import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ThemeOne from "../themes/theme-one";
import ProductsDropdown from "../components/Header/ProductsDropdown";
import Customers from "../components/Customers/Customers";
// import Resources from "../components/Resources/Resources";
import DynamicProduct from "../components/Products/DynamicProduct";
import DynamicSolution from "../components/Solutions/DynamicSolution";
import Preloader from "../components/Miscellaneous/Preloader";
import ScrollToTop from "../components/Miscellaneous/ScrollToTop";
import DynamicPlatform from "../components/Platforms/DynamicPlatform";
import DynamicCompany from "../components/Company/DynamicCompany";
import RequestDemo from "../components/Header/RequestDemo";
import DynamicCustomer from "../components/Customers/DynamicCustomer";
import PrivacyPolicy from "../components/privacyPolicy/privacyPolicy";

const MyRoutes = () => {
  return (
    <Router>
      <Preloader />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<ThemeOne />} />
        <Route path="/product-dropdown" element={<ProductsDropdown />} />
        <Route path="/product/:productName" element={<DynamicProduct />} />
        <Route path="/solution/:solutionName" element={<DynamicSolution />} />
        <Route path="/platform/:platformName" element={<DynamicPlatform />} />
        <Route path="/Customers" element={<Customers />} />
        <Route path="/Customers" element={<DynamicCustomer />} />
        <Route path="/company/:companyName" element={<DynamicCompany />} />
        <Route path="/request-demo" element={<RequestDemo />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
};

export default MyRoutes;
